import { Component, OnInit, Inject } from '@angular/core';
import { SolicitudesService } from '../../servicios/solicitudes.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-documentacion-form',
  templateUrl: './documentacion-form.component.html',
  styleUrls: ['./documentacion-form.component.css']
})
export class DocumentacionFormComponent implements OnInit {

	observaciones
  constructor(
	  private solicitudesService : SolicitudesService,
	  @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {

  }
  confirmarDocumentacion() {
	this.solicitudesService.enviarSolicitudCorreccion({Solicitud_ID:this.data , Observaciones:this.observaciones}).subscribe(res => {

	})
  }

}
